import { css } from '@appd/uik';
import { CSSProperties } from 'react';

export const getStyles = (): Record<string, string | css.Styles | CSSProperties> => ({
  COLLAPSE_PANEL: css({
    display: 'grid',
    gap: 12,
  }),
  NUMBER_INPUT: {
    width: 92,
  },
  PANEL: 'flex flex-col h-full gap-4',
  PROPERTY: 'grid gap-1.5',
  PROPERTY_LABEL: 'text-sm font-semibold text-default-text leading-5',
  TOGGLE_BUTTON: css({
    display: 'flex',
    flex: 1,
  }),
});
